import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import endpoints from "../../endpoint";
import { toast } from "react-toastify";

// cartItems fetch
export const fetchCartItem = createAsyncThunk(
  "/cart/fetchCartItem",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        endpoints.serverBaseUrl + "api/student/cartItems",
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response?.data?.items;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

// fetching cart items count
export const fetchCartCountThunk = createAsyncThunk(
  "/cart/fetchCartCount",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        endpoints.serverBaseUrl + "api/student/cartCount",
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response?.data?.data?.count;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

// Add Items to cart
export const addToCartThunk = createAsyncThunk(
  "/cart/addToCart",
  async (courseId, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        endpoints.serverBaseUrl + "api/student/cart",
        { courseId },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (response?.data?.success) {
        toast.success(response?.data?.message);
      }

      if (response?.data?.error) {
        toast.error(response?.data?.message);
      }

      return response?.data;
    } catch (error) {
      toast.error(error?.message);
      return rejectWithValue(error?.message);
    }
  }
);

export const removeItemmCart = createAsyncThunk(
  "/cart/removeCart",
  async (courseId, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        endpoints.serverBaseUrl + "api/student/delete",
        {
          courseId: courseId,
        },
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (response?.data?.success) {
        toast.success(response?.data?.message);
      }
      if (response?.data?.error) {
        toast.error(response?.data?.message);
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message);
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// export const fetchAllCourse = createAsyncThunk(
//   "/student/allCourse",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(endpoints.serverBaseUrl + "api/student");
//       return response?.data?.data;
//     } catch (error) {
//       return rejectWithValue(error?.response?.data || error?.message);
//     }
//   }
// );
//

// maked changes for a partner to get the courses and also for the student to get the courses
export const fetchAllCourse = createAsyncThunk(
  "/student/allCourse",
  async (_, { rejectWithValue }) => {
    try {
      // Get partner ID from session storage
      const storedUser = JSON.parse(sessionStorage.getItem("user"));
      const partnerId =
        storedUser?.role === "partner" ? storedUser.userId : null;

      // Prepare request URL with partner ID (if applicable)
      const url = partnerId
        ? `${endpoints.serverBaseUrl}api/student?ref=${partnerId}`
        : `${endpoints.serverBaseUrl}api/student`;

      const response = await axios.get(url);
      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

export const fetchAllTeacher = createAsyncThunk(
  "/student/allTeacher",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        endpoints.serverBaseUrl + "api/student/teachers",
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response?.data?.teachers;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message);
    }
  }
);

const cartSlice = createSlice({
  name: "studentSlice",
  initialState: {
    cartCount: 0,
    cartItem: [],
    course: [],
    loading: false,
    error: null,
    teachers: [],
    fetched: false,
  },
  reducers: {
    addToCartCount: (state, action) => {
      state.cartCount = action.payload;
    },
    removeItemFromCart: (state, action) => {
      state.cartItem = state?.cartItem?.filter(
        (item) => item?.courseId?._id !== action?.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder

      // fetching the items in the card
      .addCase(fetchCartItem.pending, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchCartItem.fulfilled, (state, action) => {
        state.loading = false;
        state.cartItem = action.payload;
        state.cartCount = action.payload.length;
      })
      .addCase(fetchCartItem.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetching the item count
      .addCase(fetchCartCountThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCartCountThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.cartCount = action.payload;
      })
      .addCase(fetchCartCountThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add items to cart
      .addCase(addToCartThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(addToCartThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.cartItem = action?.payload?.items;
        state.cartCount = action?.payload?.items?.length;
      })
      .addCase(addToCartThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // remove items from cart
      .addCase(removeItemmCart.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeItemmCart.fulfilled, (state, action) => {
        state.loading = false;
        state.cartCount = state.cartItem.length;
      })
      .addCase(removeItemmCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetch all courses
      .addCase(fetchAllCourse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCourse.fulfilled, (state, action) => {
        state.loading = false;
        state.course = action.payload;
      })
      .addCase(fetchAllCourse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // fetch all Teachers
      .addCase(fetchAllTeacher.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllTeacher.fulfilled, (state, action) => {
        state.loading = false;
        state.teachers = action.payload;
      })
      .addCase(fetchAllTeacher.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { addToCartCount, addItemToCart, removeItemFromCart } =
  cartSlice.actions;
export default cartSlice.reducer;
